import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from '@base-components';
import { PageFrontmatter } from '@interfaces';
import { useSiteData } from '@context';

/**
 * Carousel Slide.
 */
const Slide: React.FC<{
  slideData: PageFrontmatter;
  backgroundColor: string;
}> = ({ slideData, backgroundColor }) => {
  const {
    title,
    teaser,
    path,
    carousel_image: carouselImage,
    cancer_type: cancerType,
  } = slideData;
  const firstName = title.split(' ')[0];
  const { siteData } = useSiteData();

  /**
   * Render.
   */
  if (carouselImage && siteData) {
    const safeImage = getImage(carouselImage);
    const translationKey = cancerType?.toLowerCase().replace(/\s|-/g, '_');
    const safeTranslationKey = translationKey ?? '';
    const translatedCancerType = siteData?.translations?.[safeTranslationKey];

    if (safeImage && cancerType) {
      return (
        <div className="slide-wrapper">
          <div className="img-container">
            <GatsbyImage image={safeImage} alt={title} />
          </div>
          <div className="slide-container">
            <div
              className={`slide-content center-vertically background-${backgroundColor}`}
            >
              <div className="slide-content-container center-vertically">
                <div className="slick-slide-header-container">
                  <h2>{title}</h2>
                  <h3>{translatedCancerType}</h3>
                </div>
                <p>{teaser}</p>
                <Link url={path} ariaHidden={true} featured={true}>
                  {`Read ${firstName}'s story`}
                  <i className="icon-arrow-right-medium" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  return null;
};
export default Slide;
